module.exports = __webpack_public_path__ + "static/img/jieshao.87d6bd59.png";